import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as React from "react"
import { Link } from "react-router-dom"
import styled from "styled-components"

import type { SideBarItemIF } from "interfaces/SideBarItemIF"

const StyledDiv = styled.div`
  width: 100%;
  padding: 1rem 0;
  text-align: left;
`

const StyledLink = styled(Link)`
  display: block;
  color: white;
`

const DisabledLink = styled.div`
  display: block;
  color: gray;
  cursor: not-allowed;
`
export const SideBarItem = (props: SideBarItemIF) => {
  if (props.disabled) {
    return (
      <StyledDiv>
        <DisabledLink>
          {props.icon && <StyledFontAwesomeIcon icon={props.icon} />}
          {props.label}
        </DisabledLink>
      </StyledDiv>
    )
  }
  return (
    <StyledDiv>
      <StyledLink to={props.url} onClick={props.action}>
        {props.icon && <StyledFontAwesomeIcon icon={props.icon} />}
        {props.label}
      </StyledLink>
    </StyledDiv>
  )
}

const StyledFontAwesomeIcon = styled(FontAwesomeIcon)`
  margin-right: 8px;
`
